import { component } from 'picoapp'
import jQuery from 'jquery'

export default component((node, ctx) => {
    
    jQuery('.banner-item').eq(0).addClass('is-visible');

    var i = 1;
    var size = jQuery('.banner-item').length;
    setInterval(function() {

        jQuery('.banner-item').removeClass('is-visible');
        jQuery('.banner-item').eq(i).addClass('is-visible');

        jQuery('.banner-header').addClass('__underline');
        i++;

        if (i == size) {
            i = 0;
        }

    }, 4000);

})